export const INSTANT_QUOTE = "Instant Quote";
export const REQUEST_CONSULTATION = "Request Consultation";
export const BOOK_APPOINTMENT = "Book Appointment";
export const CALL_US = "Call Us";
export const FAQS = "FAQs";
export const ASK_A_QUESTION = "Ask A Question";
export const URL = "Url";
export const GET_INSTANT_QUOTE = "Get Instant Quote";
export const CALL = "Call";
